import React from 'react';
import Skeleton from 'ati-ui-react/components/Skeleton';
import * as styles from './RatingHeaderLoading.scss';

const RatingHeaderLoading = ({ isMobile }) => (
  <div className={styles.header}>
    <div className={styles.countContainer}>
      <Skeleton className={styles.count} />
    </div>
    {!isMobile && (
      <>
        <div className={styles.passportContainer}>
          <Skeleton className={styles.passportSkeleton} />
        </div>
        <div className={styles.recsContainer}>
          <Skeleton className={styles.recsSkeleton} />
        </div>
        <div className={styles.claimsContainer}>
          <Skeleton className={styles.claimsSkeleton} />
        </div>
      </>
    )}
  </div>
);

export default RatingHeaderLoading;
